/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "Yẹ́stadè",
        "0": "Todè",
        "1": "Tumọ́ro",
        "future": {
          "one": "Fọ {0}dè wé de kọm",
          "other": "Fọ {0}dè wé de kọm"
        },
        "past": {
          "one": "{0} dè wé dọ́n pas",
          "other": "{0} dè wé dọ́n pas"
        }
      },
      "day-narrow": {
        "-1": "Yẹ́stadè",
        "0": "Todè",
        "1": "Tumọ́ro",
        "future": {
          "one": "Fọ {0}dè wé de kọm",
          "other": "Fọ {0}dè wé de kọm"
        },
        "past": {
          "one": "{0} dè wé dọ́n pas",
          "other": "{0} dè wé dọ́n pas"
        }
      },
      "day-short": {
        "-1": "Yẹ́stadè",
        "0": "Todè",
        "1": "Tumọ́ro",
        "future": {
          "one": "Fọ {0}dè wé de kọm",
          "other": "Fọ {0}dè wé de kọm"
        },
        "past": {
          "one": "{0} dè wé dọ́n pas",
          "other": "{0} dè wé dọ́n pas"
        }
      },
      "hour": {
        "0": "Dís áwa",
        "future": {
          "one": "Fọ {0} áwa wé de kọm",
          "other": "Fọ {0} áwa wé de kọm"
        },
        "past": {
          "one": "{0} áwa wé dọ́n pas",
          "other": "{0} áwa wé dọ́n pas"
        }
      },
      "hour-narrow": {
        "0": "Dís áwa",
        "future": {
          "one": "Fọ {0} áwa wé de kọm",
          "other": "Fọ {0} áwa wé de kọm"
        },
        "past": {
          "one": "Fọ {0} áwa wé de kọm",
          "other": "Fọ {0} áwa wé de kọm"
        }
      },
      "hour-short": {
        "0": "Dís áwa",
        "future": {
          "one": "Fọ {0} áwa wé de kọm",
          "other": "Fọ {0} áwa wé de kọm"
        },
        "past": {
          "one": "{0} áwa wé dọ́n pas",
          "other": "{0} áwa wé dọ́n pas"
        }
      },
      "minute": {
        "0": "Dís mínit",
        "future": {
          "one": "Fọ {0} mínit wé de kọm",
          "other": "Fọ {0} mínit wé de kọm"
        },
        "past": {
          "one": "{0} mínit wé dọ́n pas",
          "other": "{0} mínit wé dọ́n pas"
        }
      },
      "minute-narrow": {
        "0": "Dís mínit",
        "future": {
          "one": "Fọ {0} mínit wé de kọm",
          "other": "Fọ {0} mínit wé de kọm"
        },
        "past": {
          "one": "{0} mínit wé dọ́n pas",
          "other": "{0} mínit wé dọ́n pas"
        }
      },
      "minute-short": {
        "0": "Dís mínit",
        "future": {
          "one": "Fọ {0} mínit wé de kọm",
          "other": "Fọ {0} mínit wé de kọm"
        },
        "past": {
          "one": "{0} mínit wé dọ́n pas",
          "other": "{0} mínit wé dọ́n pas"
        }
      },
      "month": {
        "-1": "Lást mọnt",
        "0": "Dís mọnt",
        "1": "Nẹ́st mọnt",
        "future": {
          "one": "Fọ {0}mọnt wé de kọm",
          "other": "Fọ {0}mọnt wé de kọm"
        },
        "past": {
          "one": "{0} mọnt wé dọ́n pas",
          "other": "{0} mọnt wé dọ́n pas"
        }
      },
      "month-narrow": {
        "-1": "Lást mọnt",
        "0": "Dís mọnt",
        "1": "Nẹ́st mọnt",
        "future": {
          "one": "Fọ {0}mọnt wé de kọm",
          "other": "Fọ {0}mọnt wé de kọm"
        },
        "past": {
          "one": "{0} mọnt wé dọ́n pas",
          "other": "{0} mọnt wé dọ́n pas"
        }
      },
      "month-short": {
        "-1": "Lást mọnt",
        "0": "Dís mọnt",
        "1": "Nẹ́st mọnt",
        "future": {
          "one": "Fọ {0}mọnt wé de kọm",
          "other": "Fọ {0}mọnt wé de kọm"
        },
        "past": {
          "one": "{0} mọnt wé dọ́n pas",
          "other": "{0} mọnt wé dọ́n pas"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "Lást kwọ́ta",
        "0": "Dís kwọ́ta",
        "1": "Nẹ́st kwọ́ta",
        "future": {
          "one": "fọ {0} kwọ́ta wé de kọm",
          "other": "fọ {0} kwọ́ta wé de kọm"
        },
        "past": {
          "one": "{0} kwọ́ta wé dọ́n pas",
          "other": "{0} kwọ́ta wé dọ́n pas"
        }
      },
      "quarter-narrow": {
        "-1": "Lást kwọ́ta",
        "0": "Dís kwọ́ta",
        "1": "Nẹ́st kwọ́ta",
        "future": {
          "one": "fọ {0} kwọ́ta wé de kọm",
          "other": "fọ {0} kwọ́ta wé de kọm"
        },
        "past": {
          "one": "{0} kwọ́ta wé dọ́n pas",
          "other": "{0} kwọ́ta wé dọ́n pas"
        }
      },
      "quarter-short": {
        "-1": "Lást kwọ́ta",
        "0": "Dís kwọ́ta",
        "1": "Nẹ́st kwọ́ta",
        "future": {
          "one": "fọ {0} kwọ́ta wé de kọm",
          "other": "fọ {0} kwọ́ta wé de kọm"
        },
        "past": {
          "one": "{0} kwọ́ta wé dọ́n pas",
          "other": "{0} kwọ́ta wé dọ́n pas"
        }
      },
      "second": {
        "0": "nau",
        "future": {
          "one": "Fọ {0} Sẹ́kọn",
          "other": "Fọ {0} Sẹ́kọn"
        },
        "past": {
          "one": "{0} sẹ́kọn wé dọ́n pas",
          "other": "{0} sẹ́kọn wé dọ́n pas"
        }
      },
      "second-narrow": {
        "0": "nau",
        "future": {
          "one": "Fọ {0} Sẹ́kọn",
          "other": "Fọ {0} Sẹ́kọn"
        },
        "past": {
          "one": "{0} sẹ́kọn wé dọ́n pas",
          "other": "{0} sẹ́kọn wé dọ́n pas"
        }
      },
      "second-short": {
        "0": "nau",
        "future": {
          "one": "Fọ {0} Sẹ́kọn",
          "other": "Fọ {0} Sẹ́kọn"
        },
        "past": {
          "one": "{0} sẹ́kọn wé dọ́n pas",
          "other": "{0} sẹ́kọn wé dọ́n pas"
        }
      },
      "week": {
        "-1": "Lást wik",
        "0": "Dís wik",
        "1": "Nẹ́st wik",
        "future": {
          "one": "Fọ {0}wik wé de kọm",
          "other": "Fọ {0}wik wé de kọm"
        },
        "past": {
          "one": "{0} wik wé dọ́n pas",
          "other": "{0} wik wé dọ́n pas"
        }
      },
      "week-narrow": {
        "-1": "Lást wik",
        "0": "Dís wik",
        "1": "Nẹ́st wik",
        "future": {
          "one": "Fọ {0}wik wé de kọm",
          "other": "Fọ {0}wik wé de kọm"
        },
        "past": {
          "one": "{0} wik wé dọ́n pas",
          "other": "{0} wik wé dọ́n pas"
        }
      },
      "week-short": {
        "-1": "Lást wik",
        "0": "Dís wik",
        "1": "Nẹ́st wik",
        "future": {
          "one": "Fọ {0}wik wé de kọm",
          "other": "Fọ {0}wik wé de kọm"
        },
        "past": {
          "one": "{0} wik wé dọ́n pas",
          "other": "{0} wik wé dọ́n pas"
        }
      },
      "year": {
        "-1": "Lást yiẹ",
        "0": "Dís yiẹ",
        "1": "Nẹ́st yiẹ",
        "future": {
          "one": "fọ {0} yiẹ wé de kọm",
          "other": "fọ {0} yiẹ wé de kọm"
        },
        "past": {
          "one": "{0} yiẹ wé dọ́n pas",
          "other": "{0} yiẹ wé dọ́n pas"
        }
      },
      "year-narrow": {
        "-1": "Lást yiẹ",
        "0": "Dís yiẹ",
        "1": "Nẹ́st yiẹ",
        "future": {
          "one": "fọ {0} yiẹ wé de kọm",
          "other": "fọ {0} yiẹ wé de kọm"
        },
        "past": {
          "one": "{0} yiẹ wé dọ́n pas",
          "other": "{0} yiẹ wé dọ́n pas"
        }
      },
      "year-short": {
        "-1": "Lást yiẹ",
        "0": "Dís yiẹ",
        "1": "Nẹ́st yiẹ",
        "future": {
          "one": "fọ {0} yiẹ wé de kọm",
          "other": "fọ {0} yiẹ wé de kọm"
        },
        "past": {
          "one": "{0} yiẹ wé dọ́n pas",
          "other": "{0} yiẹ wé dọ́n pas"
        }
      }
    },
    "locale": "pcm"
  });
}